import {
  AfterViewInit,
  Component,
  ElementRef,
  HostListener,
  NgZone,
  OnInit,
  ViewChild,
} from "@angular/core";
import {
  UntypedFormBuilder,
  UntypedFormControl,
  UntypedFormGroup,
  Validators,
} from "@angular/forms";
import { MatDialog } from "@angular/material/dialog";
import { ActivatedRoute, Router } from "@angular/router";
import { Subscription } from "rxjs";
import { AlertService } from "src/app/providers/alert.service";
import { ApiService } from "src/app/providers/api.service";
import { AuthService } from "src/app/providers/auth.service";
import { LoaderServiceService } from "src/app/providers/loader-service.service";
import { StorageService } from "src/app/providers/storage.service";
import { CustomConfirmDialogComponent } from "src/app/shared/components/custom-confirm-dialog/custom-confirm-dialog.component";
import { SM_CONSTANTS } from "src/app/shared/constants/sm-constants";
import { COUNTRY_CODES } from "src/app/shared/data/country-codes";
import { environment } from "src/environments/environment";

@Component({
  selector: "sm-login-form",
  templateUrl: "./login-form.component.html",
  styleUrls: ["./login-form.component.scss"],
})
export class LoginFormComponent implements OnInit, AfterViewInit {
  signInForm!: UntypedFormGroup;
  name: UntypedFormControl;
  dob: UntypedFormControl;
  gender: UntypedFormControl;
  address: UntypedFormControl;
  referralCode: string = "";
  registrationDone: boolean = false;
  profileDone: boolean = false;
  isAlreadyRegistered!: string;
  onMobileDevice: boolean = false;
  private _apiSubscription!: Subscription;
  userPhoneNumber!: string;
  @ViewChild("submitButton", { read: ElementRef, static: true })
  submitButton!: ElementRef<HTMLButtonElement>;
  @ViewChild("toHide", { read: ElementRef, static: true })
  toHide!: ElementRef<HTMLButtonElement>;

  @ViewChild("finalButton", { read: ElementRef, static: true })
  finalButton!: ElementRef<HTMLButtonElement>;
  @ViewChild("semiFinalButton", { read: ElementRef, static: true })
  semiFinalButton!: ElementRef<HTMLButtonElement>;
  countryList: {name: string; dial_code: string; code: string; flag: string; preferred?: any;}[] = COUNTRY_CODES;
  countryCode: UntypedFormControl = new UntypedFormControl(this.countryList.find(country => country.dial_code === '+91'), Validators.required);;
  firstFormGroup = this._formBuilder.group({
    phoneNo: new UntypedFormControl(null, [
      Validators.required,
      Validators.minLength(10),
      Validators.maxLength(10),
      Validators.pattern(SM_CONSTANTS.REGEX_TYPE_NUMBER),
    ]),
    country: this.countryCode,
  });
  secondFormGroup = this._formBuilder.group({
    otp: new UntypedFormControl("", [
      Validators.required,
      Validators.minLength(6),
      Validators.maxLength(6),
      Validators.pattern(SM_CONSTANTS.REGEX_TYPE_NUMBER),
    ]),
  });
  isLinear = false;
  needToRegister: boolean = false;
  toshowblockedmessage:boolean = false
  blockedUserData:any
  blockedUserGrievance:any
  @HostListener('window:resize', ['$event'])
  onResize(event: any): void {
    // Check screen width on window resize
    this.checkScreenWidth();
  }
  constructor(
    private _formBuilder: UntypedFormBuilder,
    private _authService: AuthService,
    private loader: LoaderServiceService,
    private dialog: MatDialog,
    public apiService: ApiService,
    private route: ActivatedRoute,
    private _storageService: StorageService,
    private _router: Router,
    private _alertService: AlertService,
    private ngZone: NgZone
  ) {
    this.name = new UntypedFormControl("", [Validators.required]);
    this.dob = new UntypedFormControl("");
    this.gender = new UntypedFormControl("", [Validators.required]);
    this.address = new UntypedFormControl("", [Validators.required]);
    this._apiSubscription = this.apiService.apiResult.subscribe((resData) => {
      // if (resData.responseType === SM_CONSTANTS.CHECK_USER_RESULT) {
      //   this.registrationDone = true
      //   this.finalButton.nativeElement.click()
      //   console.log(resData);
      //   if(resData.result.errorcode == '1'){
      //     console.log('yes');

      //     this.isAlreadyRegistered = 'yes'

      //     // this.loader.showLoader = false
      //   }
      //   else if(resData.result.errorcode == '0'){
      //     console.log('no');
      //     this.isAlreadyRegistered = 'no'
      //     // this.finalButton.nativeElement.click()
      //     // this.loader.showLoader = false
      //   }

      // }
      if (resData.responseType === SM_CONSTANTS.CHECK_USER_RESULT) {
        this.loader.showLoader = false
        console.log(resData);

        if (resData.result) {
          
          this._storageService.setLocalStorageValue(
            SM_CONSTANTS.KEY_ACCOUNT_PHONE_NUMBER,
            this.userPhoneNumber
          );

          if(resData.result.block_status && resData.result.block_status == '2'){
            this.blockedUserData = resData.result
            this.toHide.nativeElement.style.display = "none";
            this.toshowblockedmessage = true
            this._authService.onSignOutWithoutRedirect()
          }
          else{
            if (resData.result.errorcode === 1) {
              this.isAlreadyRegistered = "yes";
              this._storageService.setLocalStorageValue(
                SM_CONSTANTS.KEY_ACCOUNT_HASH_ID,
                resData.result.accountHashID
              );
  
              //registered but no profile
              if (
                !resData.result.profile_hash ||
                resData.result.profile_hash == "null"
              ) {
                this.needToRegister = true;
                setTimeout(() => {
                  this.finalButton.nativeElement.click();
                }, 50);
              }
  
              //registered and having profie
              else if (
                resData.result.profile_hash &&
                resData.result.profile_hash != "null"
              ) {
                //( make cases for mobile and laptop)
              
  
  
  
                this.checkScreenWidth()
                console.log(this.currentScreenWidth);
                
                if(this.currentScreenWidth >= 1200){
                  
                  this._router.navigateByUrl("/dashboard").then((_) => {
                    this._alertService.onOpenSnackbar("Logged in successfully");
                  });
                }
                else{
                  this.toHide.nativeElement.style.display = "none";
                  this.registrationDone = true
                  this._authService.onSignOutWithoutRedirect()
                }
  
  
  
  
              } else {
                this._alertService.onOpenSnackbar(
                  "Some error occured. Please try again."
                );
              }
            } else if (resData.result.errorcode === 0) {
              this.isAlreadyRegistered = "no";
              this._storageService.setLocalStorageValue(
                SM_CONSTANTS.KEY_ACCOUNT_HASH_ID,
                resData.result.accountHashID
              );
              this.needToRegister = true;
  
              setTimeout(() => {
                this.finalButton.nativeElement.click();
              }, 50);
            } else {
              this._alertService.onOpenSnackbar(resData.result.message, 4000);
            }
          }

          
        }
      }

      if (
        resData.responseType === SM_CONSTANTS.RESULT_API_UPDATE_USER_PROFILE
      ) {
        console.log(resData);
        if (resData.result) {
          if (resData.result.errorcode == 0) {
            this.loader.showLoader = false;

            //( make cases for mobile and laptop)
          



            this.checkScreenWidth()
              console.log(this.currentScreenWidth);
            if(this.currentScreenWidth >= 1200){
              this._router.navigateByUrl("/dashboard").then((_) => {
                this._alertService.onOpenSnackbar("Signed-up successfully");
              });
            }
            else{
              this.toHide.nativeElement.style.display = "none";
              this.registrationDone = true
              this._authService.onSignOutWithoutRedirect()
            }




           
          }
        } else {
          this._alertService.onOpenSnackbar(
            "Some error occured. Please try again."
          );
        }
      }
      if(resData.responseType === SM_CONSTANTS.RESULT_API_SEND_UNBLOCK_REQUEST){
        if(resData.result){
          this.loader.showLoader=false
          const dialogRef = this.dialog.open(CustomConfirmDialogComponent,{
            data : {
              title : 'Success!',
              message : 'Your request has been submitted successfully.',
              okbtn : 'Ok',
              type : SM_CONSTANTS.CUSTOM_DIALOG_ALERT_TYPE
            },
            disableClose : true
          });
          dialogRef.afterClosed().subscribe(result=>{
            window.location.reload()
          })
        }
      }
    });
  }
  ngOnInit(): void {
    this.checkScreenWidth();
    this.signInForm = new UntypedFormGroup({
      name: this.name,
      dob: this.dob,
      gender: this.gender,
      address: this.address,
    });
    this.route.queryParams.subscribe((data) => {
      console.log(data);
      this.referralCode = data.code;
    });
    if (this.referralCode) {
      sessionStorage.setItem("referralCode", this.referralCode);
    }

    this.finalButton.nativeElement.style.display = "none";
    this.semiFinalButton.nativeElement.style.display = "none";

    this._authService.initRecaptcha(this.submitButton.nativeElement);
  }
  onOtpType(){
    if(this.secondFormGroup.value.otp.length === 6){
      this.isOtpInValid = false
    }
    else{
      this.isOtpInValid = true
    }
  }
  ngAfterViewInit(): void {
    
  }
  isOtpInValid: boolean =true;
  numberOnly(event: { which: any; keyCode: any }): boolean {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      
      return false;
    }
    if(this.secondFormGroup.value.otp.length == 5){
      this.isOtpInValid = false
    }
    return true;
  }
  otpReceived: boolean = false;
  onLoggedIn: boolean = false;
  onSendOTP() {
    console.log(this.firstFormGroup);
    this.userPhoneNumber = this.firstFormGroup.value['country'].dial_code + this.firstFormGroup.value.phoneNo;
    this.secondFormGroup.get("otp")?.setValue("");

    localStorage.setItem(
      SM_CONSTANTS.KEY_ACCOUNT_PHONE_NUMBER,
      this.firstFormGroup.value['country'].dial_code + this.firstFormGroup.value.phoneNo
    );
    // localStorage.setItem(SMarketConstant.LOOKZUP_USER_NAME,this.userInfoFormGroup.value.name);
    // this.sendingOtpStatus = true;

    this._authService
      .onReceiveOTP(
        localStorage.getItem(SM_CONSTANTS.KEY_ACCOUNT_PHONE_NUMBER)!
      )
      .then((res) => {
        console.log(res);
        this.otpReceived = true;
        this.semiFinalButton.nativeElement.click();
        this.isOtpInValid = true
        console.log(this.isOtpInValid);
        
        // this.sendingOtpStatus = !res;
        // this.otpReceived = res;
        // this.userInfoFormGroup.get('phoneNumber')?.disable();
        // this.userInfoFormGroup.get('otp')?.setValue(null)
        // this.submitButton.nativeElement.style.display="block";
      }).catch(err => {
        console.log(err);
        
      })
      ;
    // this.activeModal.close(data);
  }

  changeMobileNumber() {
    this.otpReceived = false;
  }

  onSignIn() {
    // this.sendingOtpStatus = true;
    this._authService
      .onSignInWithPhone(this.secondFormGroup.value["otp"])
      .then((res) => {
        if (res) {
          console.log(res);
          localStorage.setItem(SM_CONSTANTS.KEY_ACCOUNT_AUTH_ID, res.user.uid);
          const apiBodyData = {
            versionCode: "1.0.0",
            appType: "web",
            appName: "business",
          };

          this.loader.showLoader = true;
          this.apiService.checkUser(
            apiBodyData,
            res.user.uid,
            localStorage.getItem(SM_CONSTANTS.KEY_ACCOUNT_PHONE_NUMBER)!,
            sessionStorage.getItem("referralCode")
          );
        }
      });
  }

  onRegister() {
    let data = {
      profileInfo: {
        name: this.signInForm.value.name,
        phone: localStorage.getItem(SM_CONSTANTS.KEY_ACCOUNT_PHONE_NUMBER),
        gender: this.signInForm.value.gender,
        dob: this.signInForm.value.dob
          ? this.formatDate(
              new Date(this.signInForm.value.dob).toLocaleDateString()
            )
          : null,
        userType: 1,
        searchType: 1,
        addressInfo: {},
        origin: 'business'
      },
    };

    data.profileInfo.addressInfo = {
      addressLine: this.formattedAddress,
      city:
        this.selectedLocation.city && this.selectedLocation.city != "null"
          ? this.selectedLocation.city
          : "null",
      state:
        this.selectedLocation.state && this.selectedLocation.state != "null"
          ? this.selectedLocation.state
          : "null",
      country:
        this.selectedLocation.country && this.selectedLocation.country != "null"
          ? this.selectedLocation.country
          : "null",
      zip:
        this.selectedLocation.zip && this.selectedLocation.zip != "null"
          ? this.selectedLocation.zip
          : "null",
      lat: this.lat && this.lat != "null" ? this.lat : "null",
      lng: this.lng && this.lng != "null" ? this.lng : "null",
    };
    Object.keys(data.profileInfo).forEach((key) => {
      if ((data.profileInfo as any)[key] === null) {
        delete (data.profileInfo as any)[key];
      }
    });
    console.log(data);

    this.loader.showLoader = true;
    this.apiService.updateUserProfile(data);
  }

  /**LOCATION AUTOCOMPLETE FUNCTION */
  GoogleAutocomplete = new google.maps.places.AutocompleteService();
  geocoder = new google.maps.Geocoder();
  autocompleteItems: any = [];
  selectedLocation: any = [];
  formattedAddress: any;
  lat: any;
  lng: any;
  updateSearchResults() {
    console.log("Text enter");
    if (
      this.signInForm.value.address == "" ||
      this.signInForm.value.address == null
    ) {
      this.autocompleteItems = [];
      return;
    }
    this.GoogleAutocomplete.getPlacePredictions(
      {
        input: this.signInForm.value.address,
      },
      (predictions: any, status: any) => {
        console.log(predictions, status);
        this.autocompleteItems = [];
        predictions.forEach((prediction: any) => {
          this.autocompleteItems.push(prediction);
        });
      }
    );
  }
  selectSearchResult(item: any) {
    console.log(item);
    this.autocompleteItems = [];
    this.geocoder.geocode(
      {
        placeId: item.place_id,
      },
      (results: any, status: any) => {
        if (status === "OK" && results[0]) {
          this.ngZone.run(() => {
            // this.personalInfoForm.value.address = results[ 0 ].formatted_address;
            this.signInForm.patchValue({
              address: results[0].formatted_address,
            });
            // this.locationSelected = true;
            let location_set: any = JSON.stringify(results[0].geometry);
            location_set = JSON.parse(location_set);
            let position = {
              lat: results[0].geometry.location.lat,
              lng: results[0].geometry.location.lng,
            };
            this.lat = location_set.location.lat;
            this.lng = location_set.location.lng;
            console.log(this.lat, this.lng);
            console.log("Latitude & Langitude", position);
            this.storeLocation(
              results[0].address_components,
              results[0].formatted_address
            );
          });
        }
      }
    );
  }
  storeLocation(location: any, formatted_address: any) {
    console.log(location);

    const selectedLocation: any = {};
    location.forEach((element: any) => {
      console.log(element, element.types.includes("postal_code"));
      if (element.types.includes("postal_code")) {
        selectedLocation.zip = element.long_name;
      } else if (element.types.includes("country")) {
        selectedLocation.country = element.long_name;
      } else if (element.types.includes("administrative_area_level_1")) {
        selectedLocation.state = element.long_name;
      } else if (element.types.includes("locality")) {
        selectedLocation.city = element.long_name;
      } else if (element.types.includes("route")) {
        selectedLocation.address = element.long_name;
      }
    });
    this.formattedAddress = formatted_address;
    this.selectedLocation = selectedLocation;
  }
  formatDate(originalDate: string): string {
    const parts = originalDate.split("/");
    const day = +parts[0];
    const month = +parts[1] - 1; // Months are 0-based in JavaScript
    const year = +parts[2];
    const date = new Date(year, month, day);

    const yyyy = date.getFullYear();
    const mm = String(date.getMonth() + 1).padStart(2, "0"); // Adding 1 to month since it's 0-based
    const dd = String(date.getDate()).padStart(2, "0");

    return `${yyyy}-${mm}-${dd}`;
  }
  currentScreenWidth:any
  private checkScreenWidth(): void {
    this.currentScreenWidth = window.innerWidth;
    console.log(this.currentScreenWidth);
    
    
   
  }

  openPrivacy(){
    window.open(environment.base_lookzup_web_url + '/privacy', '_blank');
  }
  openTerms(){
    window.open(environment.base_lookzup_web_url + '/terms', '_blank');
  }

  openLink(link:string): void {
    window.open(link, '_blank');
  }



  searchString: UntypedFormControl = new UntypedFormControl('');

  onCountrySelected(event: any): void {
    this.searchString.reset()
    this.countryList = COUNTRY_CODES
  }

  onKey() {
    console.log(this.searchString.value);

    this.countryList= [];
    this.selectSearch(this.searchString.value);
}

selectSearch(value:string){
  let filter = value.toLowerCase();
  for ( let i = 0 ; i < COUNTRY_CODES.length; i ++ ) {
      let option = COUNTRY_CODES[i];
      if (  option.name.toLowerCase().indexOf(filter) >= 0) {
          this.countryList.push( option );
      }
  }
}
sendUnblockRequest(){
  let data = {
    "message": this.blockedUserGrievance, 
    "block_hash": this.blockedUserData.block_hash_id, 
    "account_hash": this.blockedUserData.accountHashID
  }

  console.log(data);

  this.loader.showLoader = true
  this.apiService.sendUnblockRequest(data)
  
}
}
